import React from 'react';
import { Alert } from '@planne-software/uni/Alert';
import { Button } from '@planne-software/uni/Button';
import { IconInfoCircle } from '@planne-software/uni/icons';

import { useTranslate } from '@src/core/hooks';

import { InlineOptionsRow } from '../styles';

type EmailInUseAlertProps = {
  onLogin: () => void;
  onRecoverPassword: () => void;
};

export const EmailInUseAlert = (props: EmailInUseAlertProps) => {
  const { onLogin, onRecoverPassword } = props;
  const { i18n } = useTranslate();

  return (
    <Alert
      data-testid='signup-email-in-use-alert'
      severity='info'
      startIcon={<IconInfoCircle />}
      title={i18n('checkout_auth_signup_email_in_use_title')}
      subTitle={i18n('checkout_auth_signup_email_in_use_message')}
      action={
        <InlineOptionsRow>
          <Button type='button' size='sm' variant='slim' color='neutral' onClick={onLogin}>
            {i18n('checkout_auth_signup_email_in_use_login')}
          </Button>
          <Button type='button' size='sm' variant='slim' color='primary' onClick={onRecoverPassword}>
            {i18n('checkout_auth_signup_email_in_use_recover')}
          </Button>
        </InlineOptionsRow>
      }
    />
  );
};

export default EmailInUseAlert;
